export const EmptyString = "—";
export const NoDataString = "Н/д";
export const SomethingWentWrong = "Что-то пошло не так!";
